import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../services/auth.service';
import { EnvService } from '../services/env.service';
import { CommonService } from '../services/common.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

	loginFrm : FormGroup;
	passData:any = [];

	constructor(
		private http: HttpClient,
		private router: Router,
		public dialogRef: MatDialogRef<any>,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) {
		this.loginFrm = new FormGroup({
			userid: new FormControl('', Validators.required),
			userpwd: new FormControl('', Validators.required)
		});
	}

	ngOnInit() {
	}

	loginForm() {
		var id = this.loginFrm.get('userid').value;
		var pwd = this.loginFrm.get('userpwd').value;

		this.authService.login(id, pwd).subscribe(
			(data) => {
				if( data['code'] == 9000 )
				{
					this.func.bottomToast("아이디 및 비밀번호를 다시 입력해주세요.");
				}
				else if( data['code'] == 1000 )
				{
					this.func.bottomToast("로그인 되었습니다.");

					this.passData['id'] = id;

					this.dialogRef.close({
						event: 'close',
						data: this.passData
					});

				}
			},
			error => {
				console.log(error);
			},
			() => {
			}
		);
	}
}
